import { render, staticRenderFns } from "./ProductsPresale.vue?vue&type=template&id=e84ad6a2"
import script from "./ProductsPresale.vue?vue&type=script&lang=js"
export * from "./ProductsPresale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports